import { SplashHero } from '../components/marketing/SplashHero';
import { ValueProps } from '../components/marketing/ValueProps';
import { Footer } from '../components/marketing/Footer';

export default function SplashPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <main className="flex-1">
        <SplashHero />
        <ValueProps />
      </main>
      <Footer />
    </div>
  );
}
